import { useMutation, useQueryClient } from "@tanstack/react-query";
import { format, parseISO } from "date-fns";
import {
  CreateTimeInLieuInput,
  UpdateTimeInLieuInput,
  ApprovalStatus,
} from "../API";
import { ApiActions, gqlMutation, toAWSDate } from ".";

export const useTimeInLieuLib = () => {
  const queryClient = useQueryClient();
  const options = {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getEmployeeWithTimeInLieus"],
      });
      queryClient.invalidateQueries({ queryKey: ["listTimeInLieus"] });
    },
  };

  const { mutateAsync: createTimeInLieu } = useMutation({
    ...gqlMutation({ req: "createTimeInLieu" }),
    ...options,
  });
  const { mutateAsync: updateTimeInLieu } = useMutation({
    ...gqlMutation({ req: "updateTimeInLieu" }),
    ...options,
  });
  const { mutateAsync: deleteTimeInLieu } = useMutation({
    ...gqlMutation({ req: "deleteTimeInLieu" }),
    ...options,
  });

  const createTimeInLieuRecord = async (
    input: CreateTimeInLieuInput,
    actions: ApiActions
  ) => {
    createTimeInLieu(
      {
        input: {
          ...input,
          dateTaken: toAWSDate(new Date(input.dateTaken ?? "")),
          approvalStatus: ApprovalStatus.pending,
        },
      },
      actions
    );
  };

  const updateTimeInLieuRecord = async (
    input: UpdateTimeInLieuInput,
    actions: ApiActions
  ) => {
    updateTimeInLieu(
      {
        input: {
          ...input,
          dateTaken: input.dateTaken
            ? format(parseISO(input.dateTaken), "yyyy-MM-dd")
            : "",
        },
      },
      actions
    );
  };

  const deleteTimeInLieuRecord = async (id: string, actions: ApiActions) => {
    deleteTimeInLieu({ input: { id } }, actions);
  };

  return {
    createTimeInLieuRecord,
    updateTimeInLieuRecord,
    deleteTimeInLieuRecord,
  };
};
